/**
 * Заглушка ленты: держит место, пока едут секции страницы.
 *
 * Зачем. Секции приходят одним запросом, и до ответа `sections === null` — то
 * есть страница рисовала шапку с меню и НИЧЕГО в теле. Владелец 13.09:
 * «страница висела 10 секунд без контента». Саму медленную ручку починили
 * (проверки видео в S3 держали цикл событий), окно стало ~0,5 с, но пустое
 * тело в нём всё равно читается как «сломалось».
 *
 * Это НЕ стартовый экран из index.html (тот живёт до первого кадра React и
 * снимается, см. bootShell.ts). Здесь — окно ПОСЛЕ монтирования: React уже
 * работает, а данных ещё нет.
 *
 * Язык заглушки общий с каталогом: класс `gen-card--skeleton` и анимация
 * `skeleton-pulse` уже используются в PopularModelsTab — второй стиль для той
 * же сущности развёл бы вид страниц.
 */

interface Props {
	/** Сколько плиток нарисовать. По умолчанию — экран десктопа. */
	tiles?: number
	/** Пропорции плитки: у ленты трендов вертикальные ролики, у каталога — квадрат. */
	ratio?: string
	/** Полоска заголовка блока над сеткой: в ленте блоки подписаны. */
	title?: boolean
}

export default function FeedSkeleton({ tiles = 5, ratio = '9 / 16', title = true }: Props) {
	return (
		// data-boot-wait: пока ленты грузятся, на экране остаётся готовая страница (src/bootShell.ts), а не заглушки.
		<div className="feed-skeleton" aria-hidden="true" data-boot-wait="">
			{title && <div className="gen-card--skeleton feed-skeleton__title" />}
			<div className="feed-skeleton__grid">
				{Array.from({ length: tiles }).map((_, i) => (
					<div key={i} className="gen-card--skeleton" style={{ aspectRatio: ratio }} />
				))}
			</div>
		</div>
	)
}
